import React from "react";
import { motion } from "framer-motion";
import { cn } from "@/lib/utils";

/**
 * One control for «where am I»: a soft, almost transparent track; the active choice is a white surface with a faint
 * shadow that glides between positions. No underline, no border, no colour. The same piece carries the case tabs,
 * Kalkyle's Sammendrag | Arbeidsposter and Tilbud's Rediger | Forhåndsvis – one thing to learn, everywhere.
 * `items`: [{ key, label, divider?, testId? }] – `divider` draws one thin line before the item.
 */
export function Segmented({ value, onChange, items, size = "md", layoutId, ariaLabel, testId, className, scroll = false }) {
  const md = size === "md";
  return (
    <div role="tablist" aria-label={ariaLabel} className={cn("inline-flex max-w-full shrink-0 items-center rounded-full bg-black/[0.045] p-[3px]", md ? "h-10" : "h-8", scroll && "overflow-x-auto [scrollbar-width:none] [&::-webkit-scrollbar]:hidden", className)} data-testid={testId} data-value={value}>
      {items.map((it) => {
        const active = value === it.key;
        return (
          <React.Fragment key={it.key}>
            {it.divider ? <span className="mx-1 h-4 w-px shrink-0 bg-black/[0.1]" aria-hidden data-testid={testId ? `${testId}-divider-${it.key}` : undefined} /> : null}
            <button type="button" role="tab" aria-selected={active} onClick={() => onChange(it.key)} className={cn("relative shrink-0 rounded-full tracking-[-0.01em] outline-none transition-colors duration-150 focus-visible:ring-2 focus-visible:ring-ring/40", md ? "h-[34px] px-3.5 text-[14px]" : "h-[26px] px-3 text-[13px]", active ? "font-semibold text-foreground" : "font-medium text-foreground/55 hover:text-foreground/85")} data-testid={it.testId} data-active={active ? "1" : "0"}>
              {active ? <motion.span layoutId={layoutId} className="absolute inset-0 rounded-full bg-white shadow-[0_1px_2px_hsl(var(--shadow-color)/0.10),0_0_0_0.5px_hsl(var(--shadow-color)/0.06)]" transition={{ type: "tween", duration: 0.18, ease: [0.2, 0.7, 0.2, 1] }} /> : null}
              <span className="relative z-10 inline-flex items-center gap-1.5">{it.label}</span>
            </button>
          </React.Fragment>
        );
      })}
    </div>
  );
}
